export {
  FinanceOffersCarouselBlock,
  type FinanceOffersCarouselBlockProps,
} from './finance-offers-carousel'
